import { DashboardBarChartDto } from './../../../../service/dto';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-bar-chart',
  standalone: false,
  templateUrl: './dashboard-bar-chart.component.html',
  styleUrl: './dashboard-bar-chart.component.scss'
})
export class DashboardBarChartComponent {
	@Input() input!: DashboardBarChartDto;
}
